import React, { Component } from 'react';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import BaseLayout from './BaseLayout';
import MapApi from '@mgc/map-client-shared/lib/MapApi';
import MigrationNotice from '../components/MigrationNotice';
import strings from '../strings';

class Login extends Component {
    render() {
        return (
            <BaseLayout>
                <div id="loginPage">
                    <MigrationNotice visible={true} />
                    <div className="row row-flex row-flush row-bordered flex-center p-y-lg">
                        <div className="text-center">
                            <a href={MapApi.getLoginUrl()}>
                                <button className="btn btn-primary btn-pill btn-lg p-l-lg p-r-lg">
                                    {strings.login}
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </BaseLayout>
        );
    }
}

export default attach(Login);



// WEBPACK FOOTER //
// ./app/views/Login.jsx